import React from 'react';
import UserControls from '../layout/UserControls';

interface PageTopBarProps {
  title: string;
  description?: string;
}

/**
 * Slim top bar that sits above page content, edge-to-edge across the inner area
 * (next to the sidebar). Used by library, coverage, and team pages to give them a
 * consistent contextual header.
 *
 * The right side of the bar always renders the shared UserControls cluster
 * (notifications, theme, account, sign-out). Full-screen builder pages that
 * don't render a PageTopBar fall back to controls in the sidebar.
 */
const PageTopBar: React.FC<PageTopBarProps> = ({ title, description }) => {
  return (
    <header className="shrink-0 h-14 px-6 lg:px-8 flex items-center gap-4 bg-surface">
      <h1 className="text-sm font-semibold uppercase tracking-wider text-neutral-900 whitespace-nowrap">
        {title}
      </h1>
      {description && (
        <>
          <span className="h-4 w-px bg-neutral-200" aria-hidden="true" />
          <p className="text-xs text-neutral-500 truncate">{description}</p>
        </>
      )}
      <div className="ml-auto flex items-center">
        <UserControls direction="horizontal" />
      </div>
    </header>
  );
};

export default PageTopBar;
